import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86389c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auto-height-content" }
const _hoisted_2 = ["src"]

import { withDefaults } from 'vue';

  export interface IProps {
    imageUrl?: string;
    height?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    imageUrl: null,
    height: { default: '100%' }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "auto-height-wrapper",
    style: _normalizeStyle({paddingBottom: __props.height})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.imageUrl,
            class: "auto-height-cover"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4))
}
}

})